import React, { useState } from "react";
import Delete from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Switch from '@mui/material/Switch';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useErrorInputs } from '../../../hooks/useErrorInputs';
import { useForm } from '../../../hooks/useForm';
import Tooltip from "@mui/material/Tooltip";
import AddTask from "@mui/icons-material/AddTask";

export const ModalAddReceiver = ({ open, onClose, onSave }) => {
    const [recipients, setRecipients] = useState([]);
    const [{ emailError, nameError, phoneError }, handleErrorInput, resetErrors] = useErrorInputs({});
    const [{ recipient_email, name, cellphone, otp }, handleInputChange, reset] = useForm({
        recipient_email: '',
        name: '',
        cellphone: '',
        otp: 0,
    });

    const handleSubmitPopup = (e) => {
        e.preventDefault();
        let isValid = true;

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!recipient_email) {
            handleErrorInput("emailError", {
                isError: true,
                messageError: 'Campo requerido'
            });
            isValid = false;
        }
        else if (!emailRegex.test(recipient_email)) {
            handleErrorInput("emailError", {
                isError: true,
                messageError: 'El email ingresado no es valido'
            });
            isValid = false;
        }

        if (!name) {
            handleErrorInput("nameError", {
                isError: true,
                messageError: 'Campo requerido'
            });
            isValid = false;
        }
        else if (name.trim().length < 4) {
            handleErrorInput("nameError", {
                isError: true,
                messageError: 'El campo debe contener al menos 4 caracteres'
            });
            isValid = false;;
        }

        if (otp && !cellphone) {
            handleErrorInput("phoneError", {
                isError: true,
                messageError: 'Campo requerido'
            });
            isValid = false;
        }
        else if (otp && !/^\d{7,15}$/.test(cellphone)) {
            handleErrorInput("phoneError", {
                isError: true,
                messageError: 'El teléfono debe tener entre 7 y 12 digitos numericos'
            });
            isValid = false;
        }

        if (!isValid)
            return;

        setRecipients((prevRecipients) => {
            const updatedRecipients = [
                ...prevRecipients,
                {
                    email: recipient_email,
                    name: name,
                    cellphone: cellphone,
                    otp: otp,
                },
            ];
            return updatedRecipients;
        });

        reset();
        resetErrors();
    };

    const handleDeleteRecipient = (index) => {
        setRecipients(recipients.filter((_, i) => i !== index));
    };

    const handleCloseAndSave = () => {
        onClose();
        onSave(recipients);
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="sm"
            PaperProps={{ style: { height: '90%' } }}
        >
            <DialogTitle>
                <Typography variant="h5">Crear Remitentes</Typography>
            </DialogTitle>
            <DialogContent>
                <form noValidate autoComplete="off" onSubmit={handleSubmitPopup}>
                    <Box sx={{ marginTop: 2 }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    error={emailError?.isError}
                                    color={(emailError?.isError) && 'error'}
                                    helperText={emailError?.messageError || ''}
                                    required
                                    fullWidth
                                    label="Correo/Usuario"
                                    placeholder="correo@gmail.com"
                                    variant="outlined"
                                    name="recipient_email"
                                    size="small"
                                    value={recipient_email}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    error={nameError?.isError}
                                    color={(nameError?.isError) && 'error'}
                                    helperText={nameError?.messageError || ''}
                                    required
                                    fullWidth
                                    label="Nombre"
                                    variant="outlined"
                                    name="name"
                                    size="small"
                                    value={name}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    error={phoneError?.isError}
                                    color={(phoneError?.isError) && 'error'}
                                    helperText={phoneError?.messageError || ''}
                                    required
                                    fullWidth
                                    label="Teléfono"
                                    variant="outlined"
                                    name="cellphone"
                                    size="small"
                                    value={cellphone}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <FormControlLabel
                                    labelPlacement="top"
                                    control={
                                        <Switch
                                            name="otp"
                                            onChange={(e) => handleInputChange({
                                                target: {
                                                    name: e.target.name,
                                                    value: e.target.checked ? 1 : 0
                                                }
                                            })}
                                            checked={otp === 1}
                                        />
                                    }
                                    label="¿Doble autenticación?"
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 2 }}>
                                <Tooltip title={'Agregar'}>
                                    <IconButton
                                        aria-label="close"
                                        sx={{
                                            color: 'blue',
                                        }}
                                        type="submit"
                                    >
                                        <AddTask />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Box>
                </form>
                <TableContainer
                    sx={{
                        height: '35vh',
                        overflow: 'auto',
                        borderBottom: 'solid 1px',
                        marginTop: 2
                    }}
                >
                    <Table
                        aria-labelledby='tableTitle'
                        size='small'
                        stickyHeader
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell>Correo/Usuario</TableCell>
                                <TableCell>Nombre</TableCell>
                                <TableCell>Teléfono</TableCell>
                                <TableCell>Autenticación</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                recipients.length === 0 ?
                                    <TableCell
                                        colSpan={7}
                                        align='center'
                                    >
                                        <Typography>No hay registros para mostrar</Typography>
                                    </TableCell>
                                    :
                                    recipients.map((user, index) => (
                                        <TableRow key={index} >
                                            <TableCell>{user.email}</TableCell>
                                            <TableCell>{user.name}</TableCell>
                                            <TableCell>{user.cellphone}</TableCell>
                                            <TableCell>{user.otp ? 'Sí' : 'No'}</TableCell>
                                            <TableCell>
                                                <IconButton
                                                    color="error"
                                                    onClick={() => handleDeleteRecipient(index)}
                                                >
                                                    <Delete />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button
                        onClick={() => {
                            resetErrors();
                            onClose();
                        }}
                        variant='contained'
                        color='primary'
                        sx={{
                            mx: 3
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant='contained'
                        color='success'
                        onClick={handleCloseAndSave}
                    >
                        Guardar
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};